module.exports = __webpack_public_path__ + "static/media/toppertje13.dd9d7e8c.webp";